<template>
    <div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model:loading="loading" v-model:error="error" error-text="请求失败，点击重新加载" success-text="刷新成功" :finished="finished"  @load="onLoad" >
                <div v-for="item in list" :key="item" class="noticeCard" @click="openAuth(item)">
                    <van-cell-group :border='false'>
                    <van-cell :value='item.createtime.substring(0,10)' is-link :border='false'>
                        <template #title>
                            <span class="customTile">{{item.title}}</span>
                        </template>
                    </van-cell>
                    </van-cell-group>
                </div>
            </van-list>
        </van-pull-refresh>
        <!-- <div v-if="isShow3" style="font-size:14px;text-align:center;margin-top:15px;color:#e0e0e0">暂无数据</div> -->
        <van-empty v-if="isShow3"   image="error" description="暂无数据" />
    </div>
</template>

<script>
import VueCookie from 'vue-cookie'
export default {
    data(){
        return {
            isShow3:false,
            refreshing:false,
            finished: false,
            loading:false,
            list:[],
            error: false,
        }
    },
    methods:{
        // 发送异步请求之后如果成功之后关闭loading
        onLoad(){
            // console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
            let data={
                openId: VueCookie.get('openId'),
                pageNum:1,
                pageSize:1000,
            }
            this.$postQuery('/Notice/getListByOpenId', data)
            .then((response) => {
                // console.log(response)
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                if(response.code==200){
                    this.list = response.data.list
                    if(this.list.length==0){
                        this.isShow3 = true
                    }
                    // this.content = response.data.list
                    // 加载状态结束
                    this.loading = false;
                    // // // 数据全部加载完成
                    if (this.list.length >= response.data.list.length) {
                        this.finished = true;
                    }
                }
            }).catch(()=>{
                this.error = true;
                this.loading = false
            })
        },
        onRefresh(){
            // 清空列表数据
            this.finished = false;
            //重新加载数据
            this.loading = true;
            this.onLoad();
        },
        openAuth(item){
            // console.log(item.content)
            this.$router.push({
                name:'通知详情',
                params:{
                    content:item.content,
                    createtime:item.createtime,
                    title:item.title,
                    createusername:item.createusername
                }
            })
        }
    }
}
</script>

<style scoped>
.noticeCard{
  margin: 0 10px;
}
.customTile{
  display:inline-block;
  width: 150px;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
}
</style>